import { Suspense } from 'react';
import InitOptions from './InitOptions';
import { StoreProvider, ThrowStoreError } from './Store';
import { BootstrapVersionProvider } from '../../../../Framework/React/Hooks/useBootstrapVersion';

window.chPasswordComplexity = async (options: InitOptions) => {
    const React = (await import('react'));
    const createRoot = (await import('react-dom/client')).createRoot;
    const ErrorBoundary = (await import('../../../../Framework/React/Components/ErrorBoundary')).default;
    const App = (await import('./App')).default;

    const container = document.getElementById(options.containerId);

    if (!container) {
        throw new Error('Container not found');
    }

    const root = createRoot(container);

    root.render(
        <BootstrapVersionProvider version={4}>
            <ErrorBoundary>
                <Suspense fallback={null}>
                    <StoreProvider>
                        <ThrowStoreError />
                        <App {...options} />
                    </StoreProvider>
                </Suspense>
            </ErrorBoundary>
        </BootstrapVersionProvider>
    );
};
